export default {"src":"/_next/static/media/us.0d4b1594.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};